import styled, { css } from 'styled-components';
import { typography } from '@legacy-vfuk/core-mixins';

export const Center = styled.div`
  display: grid;
  place-items: center;
  height: 100%;
`;

export const TestimonialContentWrapper = styled.div<{ isAvatar: boolean }>`
  ${props => `
    margin-bottom: ${props.isAvatar ? '0' : '20px'};
    [class^='Headingstyle__Heading-sc'] {
      text-align: center;

      @media (min-width: 768px) {
        ${props.isAvatar ? 'text-align: center;' : 'text-align: left;'}
      }
    }

    [class^='Paragraphstyle__Paragraph-sc'] {
      text-align: center;
      @media (min-width: 768px) {
        ${props.isAvatar ? 'text-align: center;' : 'text-align: left;'}
      }
    }

    [data-component-name="PhotoAvatar"] {
      width: 120px;
      height: 120px;
    }
  `}
`;

export const FeedBackWrapper = styled.div`
  p {
    ${typography.heading(2, true)}
  }

  [class^='RichTextstyles__ParsedContentWrapper'] {
    margin-bottom: 1rem;
  }
`;
